import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Archive } from "../../../@types/archive";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

export const uploadArchive = createAsyncThunk(
  "documentCreate/uploadArchive",
  async (file: any, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const { data: archiveCreated } = await axiosInstance.post(`${api.baseURL}archive`, formData);

      return archiveCreated as Archive;
    } catch (error:any) {
      const {message} = error
      rejectWithValue(message);
      throw message;
    }
  }
);
